var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('board-filtered-search',{attrs:{"data-testid":"issue-board-filtered-search","tokens":_vm.tokens}})}
var staticRenderFns = []

export { render, staticRenderFns }